import Vue from 'vue';
import Router from 'vue-router';
import VueMeta from 'vue-meta';
import VueYandexMetrika from 'vue-yandex-metrika';

import routes from './routes';

Vue.use(Router);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
});

const router = new Router({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});


Vue.use(VueYandexMetrika, {
  id: 53878270,
  router,
  env: process.env.NODE_ENV,
  options: { clickmap: true, trackLinks: true, accurateTrackBounce: true },

});

router.beforeEach((to, from, next) => {
  if (to.params.projectSlug === 'contacts') {
    next({
      name: 'contacts-page',
    });
  } else if (to.params.projectSlug === 'calc') {
    next({
      name: 'calc-page',
    });
  }

  if (from.query.in_gamecenter && !to.query.in_gamecenter) {
    if (to.path === from.path) {
      // This is a no-no via the documentation, but a bug
      // in routing to identical routes strips query params, and this prevents that
      return;
    }
    next({ path: to.path, query: { in_gamecenter: from.query.in_gamecenter } });
  }

  next();
});

export default router;
